<template>
  <div class="row">
    <div class="col-md-12">
      <ul class="list-group" v-if="applications.length > 0">
        <app-application v-for="application of applications" :application="application" :key="application._id"></app-application>
      </ul>
      <div class="col-md-12 mt-4">
        <router-link tag="button" :to="{name:'ApplicationsCreate'}" class="btn btn-lg btn-primary">Create Application</router-link>
      </div>
    </div>
  </div>
</template>

<script>

  import Application from '../components/Application.vue';
  import {eventBus} from "../main";
  import apiMixin from '../mixins/api.js';

  export default {
    mixins: [apiMixin],
    data(){
      return {
        applications: []
      }
    },
    components: {
      appApplication: Application
    },
    methods: {
      async getApplications(){
        const data = await this.apiApplicationsGet();

        this.applications = data.data;
      }
    },
    created() {
      this.getApplications();

      eventBus.$on('applicationDeleted', () => {
        this.getApplications();
      });

    }
  }
</script>